import { render, staticRenderFns } from "./profileNotifications.vue?vue&type=template&id=e6aaf042&scoped=true&"
import script from "./profileNotifications.vue?vue&type=script&lang=js&"
export * from "./profileNotifications.vue?vue&type=script&lang=js&"
import style0 from "./profileNotifications.vue?vue&type=style&index=0&id=e6aaf042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6aaf042",
  null
  
)

export default component.exports